import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React, { useContext } from 'react'
import CONFIG from '../../../config'
import { Context } from '../../../contexts/Context'

export default function Filter () {
  const { handleFilterRange, handleClinicClick, filters } = useContext(Context)
  const handleChange = (e) => {
    handleClinicClick(null)
    handleFilterRange(e.target.value)
  }

  return (
    <FormControl sx={{ maxWidth: 150 }} size='small' fullWidth>
      <InputLabel sx={{ lineHeight: 1, fontSize: 16 }} id='demo-simple-select-label filter_by'>Distance</InputLabel>
      <Select
        sx={{ background: 'white', height: 30, borderRadius: '10px' }}
        labelId='demo-simple-select-label'
        id='demo-simple-select'
        value={filters.range}
        label='Distance'
        onChange={handleChange}
      >
        {CONFIG.distanceRange?.map((dist, i) =>
          <MenuItem key={i} value={dist}>{dist} km</MenuItem>
        )}
      </Select>
    </FormControl>
  )
}
